<div>
  <div mat-dialog-title>
    <mat-icon mat-dialog-close>close</mat-icon>
    <h3>{{ 'warnings.title' | transloco }}</h3>
  </div>
  <mat-dialog-content>
    <p>
      {{ 'warnings.process.body' | transloco }}
    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button class="full-button" (click)="dialog.closeAll()">{{ 'warnings.process.button' | transloco }}</button>
  </mat-dialog-actions>
</div>
